import { Group, Stack, Text, Title } from '@mantine/core';
import { capitalize } from 'lodash';

import { TransitRequestForGuaranteeError } from '@e-origin/shared';

interface TransitGuaranteeErrorsProps {
  errors: TransitRequestForGuaranteeError[];
}

export const TransitGuaranteeErrors: React.FC<TransitGuaranteeErrorsProps> = ({ errors }) => {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <Stack mt="md" px="sm">
      {errors.map((error, idx) => (
        <Stack key={idx} mb="xs">
          <Title order={5} fw={600}>
            {capitalize(error.errorType)} error
          </Title>
          <Group>
            {error.sequenceNumber && (
              <Stack>
                <Text c="gray" size="sm">
                  Sequence number
                </Text>
                <Text fw={500}>{error.sequenceNumber}</Text>
              </Stack>
            )}
            <Stack>
              <Text c="gray" size="sm">
                Error code
              </Text>
              <Text fw={500}>{error.errorCode}</Text>
            </Stack>
            {error.errorPointer && (
              <Stack>
                <Text c="gray" size="sm">
                  Error pointer
                </Text>
                <Text fw={500}>{error.errorPointer}</Text>
              </Stack>
            )}
          </Group>
          {error.errorReason && (
            <Stack>
              <Text c="gray" size="sm">
                Error reason
              </Text>
              <Text fw={500}>{error.errorReason}</Text>
            </Stack>
          )}
          {error.remarks && (
            <Stack>
              <Text c="gray" size="sm">
                Remarks
              </Text>
              <Text fw={500}>{error.remarks}</Text>
            </Stack>
          )}
          {error.originalAttributeValue && (
            <Stack>
              <Text c="gray" size="sm">
                Original Attribute
              </Text>
              <Text fw={500}>{error.originalAttributeValue}</Text>
            </Stack>
          )}
        </Stack>
      ))}
    </Stack>
  );
};
